import { faCommand } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, BadgeVariants } from "~/components/Badge";
import { faKeyboard } from "@fortawesome/pro-regular-svg-icons";
import { useIsMobile } from "~/hooks/use-mobile";

// // // //

export function HotkeyBadge(props: { isAppleOS: boolean }) {
    const { isAppleOS } = props;
    const isMobile = useIsMobile();
    const icon = isAppleOS ? faCommand : faKeyboard;
    const label = isAppleOS ? "CMD + K" : "CTRL + K";

    if (isMobile) {
        return null;
    }

    return (
        <Badge
            label={
                <>
                    <FontAwesomeIcon
                        icon={icon}
                        className="top-3 h-3 w-3 mr-1.5"
                        aria-hidden="true"
                    />
                    {label}
                </>
            }
            size="sm"
            rounded="sm"
            variant={BadgeVariants.blue}
            className="pointer-events-none absolute right-4 top-2.5 border border-primary-dark/20"
        />
    );
}
